module.exports = __webpack_public_path__ + "img/pills.439cb6d7.svg";